import login from './login/apiLogin.js'

export default {
  ...login,
}
